export function getChromeExtensionOrigin(): string | null {
  return typeof window !== 'undefined' && window.location.ancestorOrigins?.length
    ? window.location.ancestorOrigins[0]
    : null;
}

export default function isInChromeExtension(): boolean {
  return getChromeExtensionOrigin()?.startsWith('chrome-extension://') ?? false;
}
